var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"chat-label__label",class:( _obj = {}, _obj["chat-label__label_unseen"] = _vm.label === 'unseen', _obj['chat-label__label_unreplied'] = _vm.label === 'unreplied', _obj )},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }